// frontend/src/components/enroll/TicketSelectionStep.js
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Modal from '../Modal/Modal';
import styled from 'styled-components';
import Typography from '../Typography';
import Button from '../Button/Button';
import TicketItem from '../EventContent/TicketItem';
import { theme } from '../../theme';
import { useTranslation } from 'react-i18next';
import ArrowRightIcon from '../Icons/ArrowRightIcon';

const TicketSelectionStep = ({ tickets, onTicketSelected, onCancel }) => {
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const { t } = useTranslation('eventEnroll');

  const handleSelect = (ticket) => {
    setSelectedTicketId(ticket._id);
  };

  return (
    // <Modal title="Selecciona tu Entrada" onClose={onCancel} maxWidth="500px" maxHeight="calc(100% - 2rem)" >
    <Modal title={t('ticketSelection.title')} onClose={onCancel} maxWidth="500px">
      <Container>
        <TicketHeading as="p" $variant="body-1-medium" $variantTablet="body-1-medium" $variantMobile="body-2-medium" color={theme.colors.defaultWeak}>
          {t('ticketSelection.subtitle')}
          {/* Elige una entrada para inscribirte: */}
        </TicketHeading>
        <TicketList>
          {tickets
            .sort((a, b) => {
              // Si un ticket está agotado (availableSeats = 0) va al final
              if (a.availableSeats === 0 && b.availableSeats > 0) return 1;
              if (b.availableSeats === 0 && a.availableSeats > 0) return -1;
              // Si ambos están agotados o ambos tienen plazas, ordenar por availableSeats descendente
              return b.availableSeats - a.availableSeats;
            })
            .map((ticket) => (
              <TicketItem
                key={ticket._id}
                ticket={ticket}
                selected={selectedTicketId === ticket._id}
                onSelect={() => handleSelect(ticket)}
              />
            ))}
        </TicketList>
      </Container>
      <Actions>
        <Button onClick={onCancel} $variant="outline" size="l">
          {t('ticketSelection.cancel')}
          {/* Cancelar */}
        </Button>
        <Button
          onClick={() => {
            const selectedTicket = tickets.find((t) => t._id === selectedTicketId);
            if (selectedTicket) onTicketSelected(selectedTicket);
          }}
          disabled={!selectedTicketId}
          size="l"
        >
          {/* Continuar */}
          {t('ticketSelection.continue')}
          <ArrowRightIcon fill={theme.colors.inverseMain} />
        </Button>
      </Actions>
    </Modal>
  );
};

TicketSelectionStep.propTypes = {
  tickets: PropTypes.array.isRequired,
  onTicketSelected: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default TicketSelectionStep;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  width: 100%;
`;

const TicketHeading = styled(Typography)`
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;

const TicketList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.sizing.xs};
  list-style: none;
  padding: ${({ theme }) => theme.sizing.sm};
  padding-top: 0;
  witdh: 100%;
`;

const Actions = styled.div`
  border-top: 1px solid ${({ theme }) => theme.border.defaultSubtle};
  display: flex;
  gap: ${({ theme }) => theme.sizing.xs};
  justify-content: space-between;
  padding: ${({ theme }) => theme.sizing.sm};
  width: 100%;
`;
